import React from "react";

export default class FileComponent extends React.Component  {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
            fileName: props.defaultFilename,
            filter: props.filter || "*",
            id: props.id,
            hint: props.hint
        }
        this.props = props;
        this.onLoaded=props.onLoaded;
        this.onValidate = props.onValidate;
        this.fileReader = new FileReader();
    }
    render() {        
        return ( <div className='form-group'>
                <label id={this.props.id+"-label"} htmlFor={this.props.id}>Select your {this.props.defaultFilename}:</label>
                <input type="file" id={this.props.id} className='form-control' accept={this.props.filter} style={{minHeight: "42px"}} onChange={(e)=>{
                    
                    let valid = this.props.onPreValidate(e.target.files[0]);
                    if (e.target.files.length > 0 && valid.ok) {
                        
                        this.fileReader.onload = (fileLoadedEvent)=>{
                            let data = null;
                            if (!fileLoadedEvent) {
                                data = this.fileReader.content;
                            }else {
                                data = fileLoadedEvent.target.result;
                            }
                            if (this.props.onPostValidate(data)){//(stringToBytes(data))) {

                                this.props.onLoaded(data);
                                this.setState({hint:"✅ Successfully loaded."});
                                this.props.onStatus(e.target.files[0].name+" successfully loaded","text-success");
                            }else{
                                this.setState({hint:"❌ Failed - "+this.props.hint})
                            }
                    }
                    this.fileReader.onerror=this.fileReader.onabort=(e)=>{
                        this.setState({hint:"❌ Failed - "+e.target.value})
                    }
                    this.fileReader.readAsArrayBuffer(e.target.files[0]);
                }else{
                    this.props.onStatus(valid.msg,"text-danger");
                    this.setState({hint:"❌ Failed"});
                } }}
                 />
                <small id={this.props.id+"note"} className='form-text text-muted'>{this.state.hint}</small>
                <input type="hidden" id={this.props.id+"content"} />
                </div>
        );
    }
}
